/**
 * ** Club Quarters**
 *
 * @exports partnership_10018
 * @category partnerships
 */
function factory({ window, document, thn }) {

  const partnership = {};

  /**
       * @memberOf module:partnership_10018
       */
  partnership.getId = function getId() {
    return '10018';
  };

  /**
       * @memberOf module:partnership_10018
       */
  partnership.check = function check() {
    return !!window.location.hostname.match(/clubquartershotels|parkterracehotel|thejewelny/);
  };

  /**
       * @memberOf module:partnership_10018
       */
  partnership.getSiteId = function getSiteId() {
    const jewelnyUrlByForm = document.querySelector('.booking-form')?.action;
    const jewelnyUrlObj = jewelnyUrlByForm && new URL(jewelnyUrlByForm);
    const jewelnyHotelId = jewelnyUrlObj && jewelnyUrlObj.searchParams.get('hotel');
    const hotelId = document.querySelector('[name="hotel"]')?.value || thn.parseUrlParameter('hotel') || jewelnyHotelId;
    const isParkTerraceHotelSelfbook = window.location.hostname.includes('parkterracehotel') && thn.data.media.name === 'mobile';

    let result;

    if (hotelId) {
      result = {
        externalId: isParkTerraceHotelSelfbook ? `${hotelId}-m` : hotelId,
      };
    } else {
      result = {
        accountKey: '6EBCA04DED7B7BDBD9C42225E8749D7F',
      };
    }

    return result;
  };

  /**
     * @memberOf module:partnership_10018
     */
  partnership.boot = function boot() {
    const containerSelfbook = document.querySelector('#selfbook_sdkwidget_wrapper');

    if (containerSelfbook) {

      const handleIdentityCheck = thn.debounce(thn.siteCheck, 1500);

      thn.observeDom(containerSelfbook, handleIdentityCheck, {
        childList: false,
        subtree: false,
        attributes: true,
        attributesFilter: ['style'],
      });

      partnership.shutdown = () => {
        handleIdentityCheck.cancel();
        thn.stopObserveDom(containerSelfbook, handleIdentityCheck);
      };
    }
  };

  return partnership;
}

export { factory };
